module.exports = __webpack_public_path__ + "static/media/cooperation3.43cc840f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/cooperation3.jpg
// module id = 210
// module chunks = 6